import { call, put } from "redux-saga/effects";
import { reviewApi } from "@services/api";
import { getCourseReviewSummaryActions } from "../slices";

function* getCourseReviewSummaryWorker({ payload }) {
  try {
    yield put(getCourseReviewSummaryActions.pending());
    const responseSummary = yield call(
      reviewApi.getReviewSummaryCourse,
      payload
    );
    const responseAvgRating = yield call(
      reviewApi.getAverageRatingCourse,
      payload
    );
    const responseTotalReviews = yield call(
      reviewApi.getTotalReviewsCourse,
      payload
    );

    const payloadSuccess = {
      ratingList: responseSummary.data,
      avgRating: responseAvgRating.data,
      totalReviews: responseTotalReviews.data,
    };

    yield put(getCourseReviewSummaryActions.success(payloadSuccess));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(getCourseReviewSummaryActions.failure());
    // TODO: handle callback | onFailure
  }
}

export { getCourseReviewSummaryWorker };
